import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

export type PersonEducation = {
	degree: string;
	end_year: number | null;
	field: string;
	id: number;
	school_id: number | null;
	school_name: string;
	linkedin_url: string | null;
	start_year: number | null;
};

export const getPersonEducationById = (
	id: number
): Promise<DRFListResponseWrapper<PersonEducation[]>> => {
	if (!id || typeof id !== "number") {
		throw new Error(
			`getPersonEducationById called with invalid argument id '${id}'. Expected number`
		);
	}

	return fetch(`/api/v2/persons/${id}/education/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
